export class TimeCell {
  time: string;
  length: number;
}